import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';
import { MenuItemModel } from '../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Quick Quiz',
    ImagePath: '/assets/images/landing/quick-quizzes.png',
    DestinationPage: 'Quick-Quiz',
  },
  {
    Text: 'Mistakes Quiz',
    ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
    DestinationPage: 'Mistakes-Quiz',
    MenuType: MenuItemTypeEnum.MistakesQuiz,
  },
  {
    Text: 'Summary Test',
    ImagePath: '/assets/images/landing/revision-summary-test.png',
    DestinationPage: 'Revision-Summary-Test',
  },
  {
    Text: 'Video Solutions',
    ImagePath: '/assets/images/landing/graph.png',
    DestinationPage: 'video-solutions',
  }
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Quick Quiz',
    ButtonURL: 'quick-quiz',

    MixedOnlineTests: [
      {
        // TODO: verify URL
        MixedOnlineTestUrl: '_revisionhub_opc/MCFR49/MCFR49_QuickQuiz',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Test yourself with quizzes covering every topic.  On your marks, get set… quiz!</p>' +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Last quiz score: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Questions on every topic',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',

    MixedOnlineTests: [
      {
        // TODO: verify URL - MistakesQuiz typically derives its data from the QuickQuiz test URL; update if different
        MixedOnlineTestUrl: '',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>The quick quiz questions you got wrong are here  -  have another go and conquer them once and for all!</p>' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.RevisionSummary,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Revision Summary Tests',
    ButtonURL: 'revision-summary-test',

    MixedOnlineTests: [
      {
        // TODO: verify URL
        MixedOnlineTestUrl: '_revisionhub_opc/MCFR49/MCFR49_RevisionSummary',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '<p>Questions marked <img src="assets/images/smiley-face-green.png" width="30" height="30" style="vertical-align:middle;" /> : <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'In-depth written questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.VideoSolutions,
    IsFreeSample: false,
    IconPath: '/assets/images/landing/graph.png',
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    // TODO: verify ButtonURL - valid options for VideoSolutions:
    //   'content-videos'       -> route: products/{code}/content-videos/{subcategory}
    //   'worked-answer-videos' -> route: products/{code}/worked-answer-videos/{subcategory}
    //   'video-solutions'      -> route: products/{code}/video-solutions/{subcategory}
    ButtonURL: 'worked-answer-videos',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Learn how to answer the exam-style questions in your book.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Step-by-step exam answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Solutions',
        Intro: '<p>CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book  -  have a go at the questions first and use these videos if you need a bit of extra help.</p>',
        LeftSections: [
          {
            Header: 'Section One  -  Number',
            Subcategories: [
              { Name: 'Wordy Real-Life Problems', ShortName: 'wordy-real-life-problems', Link: 'https://www.youtube.com/embed/n2dcbEwZCHo?rel=0&modestbranding=1' },
              { Name: 'Dividing Whole Numbers', ShortName: 'dividing-whole-numbers', Link: 'https://www.youtube.com/embed/VGG7YZtxdo4?rel=0&modestbranding=1' },
              { Name: 'Dividing Decimals', ShortName: 'dividing-decimals', Link: 'https://www.youtube.com/embed/DJQjzeweq7E?rel=0&modestbranding=1' },
              { Name: 'Finding Prime Factorisations', ShortName: 'finding-prime-factorisations', Link: 'https://www.youtube.com/embed/jh880F9upVc?rel=0&modestbranding=1' },
              { Name: 'Finding the Lowest Common Multiple', ShortName: 'finding-the-lowest-common-multiple', Link: 'https://www.youtube.com/embed/mFwiP_e5Yoc?rel=0&modestbranding=1' },
              { Name: 'Fractions without a Calculator', ShortName: 'fractions-without-a-calculator', Link: 'https://www.youtube.com/embed/GaCqLPbB_s8?rel=0&modestbranding=1' },
              { Name: 'Fraction Problems', ShortName: 'fraction-problems', Link: 'https://www.youtube.com/embed/QhMjl2Q1y9w?rel=0&modestbranding=1' },
              { Name: 'Rounding - Significant Figures', ShortName: 'rounding-significant-figures', Link: 'https://www.youtube.com/embed/toGvZ1C_-tI?rel=0&modestbranding=1' },
              { Name: 'Rounding Errors', ShortName: 'rounding-errors', Link: 'https://www.youtube.com/embed/AKDvFI7CKQ4?rel=0&modestbranding=1' },
              { Name: 'Using Power Rules', ShortName: 'using-power-rules', Link: 'https://www.youtube.com/embed/elTtZAqg7ss?rel=0&modestbranding=1' },
              { Name: 'Standard Form', ShortName: 'standard-form', Link: 'https://www.youtube.com/embed/vqr7YDp-pnc?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Two  -  Algebra',
            Subcategories: [
              { Name: 'Multiplying Out Brackets', ShortName: 'multiplying-out-brackets', Link: 'https://www.youtube.com/embed/PYrJBfZTc08?rel=0&modestbranding=1' },
              { Name: 'The Difference of Two Squares', ShortName: 'the-difference-of-two-squares', Link: 'https://www.youtube.com/embed/nV_d9Rl34IU?rel=0&modestbranding=1' },
              { Name: 'Solving Equations', ShortName: 'solving-equations', Link: 'https://www.youtube.com/embed/FAvRn0AKf-8?rel=0&modestbranding=1' },
              { Name: 'Forming Equations from Words', ShortName: 'forming-equations-from-words', Link: 'https://www.youtube.com/embed/069Q6Q6ivCc?rel=0&modestbranding=1' },
              { Name: 'Forming Equations From Diagrams', ShortName: 'forming-equations-from-diagrams', Link: 'https://www.youtube.com/embed/mYjgvwowObA?rel=0&modestbranding=1' },
              { Name: 'Sequences', ShortName: 'sequences', Link: 'https://www.youtube.com/embed/R6OHZA2Njvk?rel=0&modestbranding=1' },
              { Name: 'Solving Quadratic Equations', ShortName: 'solving-quadratic-equations', Link: 'https://www.youtube.com/embed/AC3BWfZ4WZc?rel=0&modestbranding=1' },
              { Name: 'Simultaneous Equations', ShortName: 'simultaneous-equations', Link: 'https://www.youtube.com/embed/rb6w96UDFZY?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Three  -  Graphs',
            Subcategories: [
              { Name: 'Coordinates and Midpoints', ShortName: 'coordinates-and-midpoints', Link: 'https://www.youtube.com/embed/OjuOGIDwbqI?rel=0&modestbranding=1' },
              { Name: 'Drawing Straight-Line Graphs', ShortName: 'drawing-straight-line-graphs', Link: 'https://www.youtube.com/embed/ETl4XA1DTPg?rel=0&modestbranding=1' },
              { Name: 'Finding the Equation of a Straight Line', ShortName: 'finding-the-equation-of-a-straight-line', Link: 'https://www.youtube.com/embed/QTnx3sakDS4?rel=0&modestbranding=1' },
              { Name: 'Drawing Quadratic Graphs', ShortName: 'drawing-quadratic-graphs', Link: 'https://www.youtube.com/embed/neO0eZbIJpQ?rel=0&modestbranding=1' },
              { Name: 'Solving Equations Using Graphs', ShortName: 'solving-equations-using-graphs', Link: 'https://www.youtube.com/embed/1Ful7WXKTd0?rel=0&modestbranding=1' },
              { Name: 'Using Distance-Time Graphs', ShortName: 'using-distance-time-graphs', Link: 'https://www.youtube.com/embed/sz3ubmzH0zo?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Four  -  Ratio, Proportion and Rates of Change',
            Subcategories: [
              { Name: 'Ratios', ShortName: 'ratios', Link: 'https://www.youtube.com/embed/C4PbyaFh698?rel=0&modestbranding=1' },
              { Name: 'Direct Proportion', ShortName: 'direct-proportion', Link: 'https://www.youtube.com/embed/ayyi7IoMf4o?rel=0&modestbranding=1' },
              { Name: 'Inverse Proportion Problems', ShortName: 'inverse-proportion-problems', Link: 'https://www.youtube.com/embed/0soC4NngTmA?rel=0&modestbranding=1' },
              { Name: 'Percentages - Finding the Original Value', ShortName: 'percentages-finding-the-original-value', Link: 'https://www.youtube.com/embed/fW_eIsJjCEU?rel=0&modestbranding=1' },
              { Name: 'Working with Percentages', ShortName: 'working-with-percentages', Link: 'https://www.youtube.com/embed/9QX_4QeidvA?rel=0&modestbranding=1' },
              { Name: 'Compound Interest', ShortName: 'compound-interest', Link: 'https://www.youtube.com/embed/MgLG8x0aCPo?rel=0&modestbranding=1' },
              { Name: 'Converting Units', ShortName: 'converting-units', Link: 'https://www.youtube.com/embed/sdkMCuo4wMo?rel=0&modestbranding=1' },
              { Name: 'Time Problems', ShortName: 'time-problems', Link: 'https://www.youtube.com/embed/ku0-rwAwTLc?rel=0&modestbranding=1' },
              { Name: 'Density', ShortName: 'density', Link: 'https://www.youtube.com/embed/we4ZTtOYrbc?rel=0&modestbranding=1' },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Section Five  -  Shapes and Area',
            Subcategories: [
              { Name: 'Symmetry', ShortName: 'symmetry', Link: 'https://www.youtube.com/embed/QKGxR3xl1Zc?rel=0&modestbranding=1' },
              { Name: 'Similar Shapes', ShortName: 'similar-shapes', Link: 'https://www.youtube.com/embed/D9Qsd2XHWZg?rel=0&modestbranding=1' },
              { Name: 'Transformations', ShortName: 'transformations', Link: 'https://www.youtube.com/embed/vQz8nGVA9ew?rel=0&modestbranding=1' },
              { Name: 'Area Problems', ShortName: 'area-problems', Link: 'https://www.youtube.com/embed/l0S1a4quBMg?rel=0&modestbranding=1' },
              { Name: 'Surface Area of a Sphere', ShortName: 'surface-area-of-a-sphere', Link: 'https://www.youtube.com/embed/qegSmCvNj5M?rel=0&modestbranding=1' },
              { Name: 'Finding the Volume of a Frustrum', ShortName: 'finding-the-volume-of-a-frustrum', Link: 'https://www.youtube.com/embed/s7E6n3obJ1U?rel=0&modestbranding=1' },
              { Name: 'Trickier Volume Problems', ShortName: 'trickier-volume-problems', Link: 'https://www.youtube.com/embed/EkSGOY9D4Pk?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Six  -  Angles and Geometry',
            Subcategories: [
              { Name: 'Parallel Lines', ShortName: 'parallel-lines', Link: 'https://www.youtube.com/embed/0NYL7A4qSZc?rel=0&modestbranding=1' },
              { Name: 'Angles and Parallel Lines', ShortName: 'angles-and-parallel-lines', Link: 'https://www.youtube.com/embed/oBM9eCz5OYQ?rel=0&modestbranding=1' },
              { Name: 'Finding Interior Angles in a Polygon', ShortName: 'finding-interior-angles-in-a-polygon', Link: 'https://www.youtube.com/embed/BjYzeBZc-DU?rel=0&modestbranding=1' },
              { Name: 'Triangle Construction', ShortName: 'triangle-construction', Link: 'https://www.youtube.com/embed/vlGBM4is22A?rel=0&modestbranding=1' },
              { Name: 'Loci', ShortName: 'loci', Link: 'https://www.youtube.com/embed/5yUhrUr8UEs?rel=0&modestbranding=1' },
              { Name: 'Maps and Scale Drawings', ShortName: 'maps-and-scale-drawings', Link: 'https://www.youtube.com/embed/MEFAtIqFQlI?rel=0&modestbranding=1' },
              { Name: 'Pythagoras\' Theorem', ShortName: 'pythagoras-theorem', Link: 'https://www.youtube.com/embed/rMiwZ3kf524?rel=0&modestbranding=1' },
              { Name: 'Trigonometry', ShortName: 'trigonometry', Link: 'https://www.youtube.com/embed/1ZA1I-2H580?rel=0&modestbranding=1' },
              { Name: 'Trigonometry - Common Values', ShortName: 'trigonometry-common-values', Link: 'https://www.youtube.com/embed/7KaEIqfs_Ws?rel=0&modestbranding=1' },
              { Name: 'Vectors', ShortName: 'vectors', Link: 'https://www.youtube.com/embed/hRtmVsC55tU?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Seven  -  Probability and Statistics',
            Subcategories: [
              { Name: 'Finding Probabilities', ShortName: 'finding-probabilities', Link: 'https://www.youtube.com/embed/yFEaMJzNa9I?rel=0&modestbranding=1' },
              { Name: 'Finding Expected Frequencies', ShortName: 'finding-expected-frequencies', Link: 'https://www.youtube.com/embed/r-I0_Iv2b8Q?rel=0&modestbranding=1' },
              { Name: 'Venn Diagrams', ShortName: 'venn-diagrams', Link: 'https://www.youtube.com/embed/HG3ytOFTVHQ?rel=0&modestbranding=1' },
              { Name: 'Mean, Median, Mode and Range', ShortName: 'mean-median-mode-and-range', Link: 'https://www.youtube.com/embed/Q2BM8D9tYOY?rel=0&modestbranding=1' },
              { Name: 'Pictograms', ShortName: 'pictograms', Link: 'https://www.youtube.com/embed/7XL9TuFASmE?rel=0&modestbranding=1' },
              { Name: 'Drawing Pie Charts', ShortName: 'drawing-pie-charts', Link: 'https://www.youtube.com/embed/NFBdej_-JaQ?rel=0&modestbranding=1' },
              { Name: 'Finding Averages from Frequency Tables', ShortName: 'finding-averages-from-frequency-tables', Link: 'https://www.youtube.com/embed/-wzFgvH2Jao?rel=0&modestbranding=1' },
              { Name: 'Grouped Frequency Tables', ShortName: 'grouped-frequency-tables', Link: 'https://www.youtube.com/embed/B_o4v1qdpvs?rel=0&modestbranding=1' },
              { Name: 'Comparing Data Sets', ShortName: 'comparing-data-sets', Link: 'https://www.youtube.com/embed/X7EXuCEV5q4?rel=0&modestbranding=1' },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.VideoExplanations,
    IsFreeSample: false,
    IconPath: '/assets/images/landing/Tilted-Protractor.png',
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch explanations',
    // TODO: verify ButtonURL - valid options for VideoExplanations:
    //   'content-videos'      -> route: products/{code}/content-videos/{subcategory}  (QuestionAndAudioComponent)
    //   'video-explanations'  -> route: products/{code}/video-explanations/{subcategory} (also QuestionAndAudioComponent)
    ButtonURL: 'content-videos',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Video Explanations',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Our experts break down key concepts for you.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Get to grips with key concepts',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Explanations',
        Intro: '<p>These handy videos explain some of the key concepts in your book. So grab your popcorn (or a pencil) and dig in!</p>',
        LeftSections: [
          {
            Header: 'Section One  -  Number',
            Subcategories: [
              { Name: 'Order of Operations', ShortName: 'order-of-operations', Link: 'https://www.youtube.com/embed/my-RmeSxynQ?rel=0&modestbranding=1' },
              { Name: 'Negative Numbers - Using Number Lines', ShortName: 'negative-numbers-using-number-lines', Link: 'https://www.youtube.com/embed/CK-VYuk5zd0?rel=0&modestbranding=1' },
              { Name: 'Mixed Numbers', ShortName: 'mixed-numbers', Link: 'https://www.youtube.com/embed/43eCuLMiiME?rel=0&modestbranding=1' },
              { Name: 'Adding and Subtracting Fractions', ShortName: 'adding-and-subtracting-fractions', Link: 'https://www.youtube.com/embed/ojVBcSVSlRU?rel=0&modestbranding=1' },
              { Name: 'Rounding - Decimals Places (DP)', ShortName: 'rounding-decimals-places-dp', Link: 'https://www.youtube.com/embed/fx5NOuyD9Sc?rel=0&modestbranding=1' },
              { Name: 'Rounding - Significant Figures (SF)', ShortName: 'rounding-significant-figures-sf', Link: 'https://www.youtube.com/embed/dlNjVKR7g2A?rel=0&modestbranding=1' },
              { Name: 'Standard Form', ShortName: 'standard-form', Link: 'https://www.youtube.com/embed/tPd4McO11Mg?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Two  -  Algebra',
            Subcategories: [
              { Name: 'Collecting Like Terms', ShortName: 'collecting-like-terms', Link: 'https://www.youtube.com/embed/zM6GzbptSnI?rel=0&modestbranding=1' },
              { Name: 'Expanding Brackets', ShortName: 'expanding-brackets', Link: 'https://www.youtube.com/embed/VzIs0URcvtE?rel=0&modestbranding=1' },
              { Name: 'Factorising', ShortName: 'factorising', Link: 'https://www.youtube.com/embed/rCsBOjRfFx8?rel=0&modestbranding=1' },
              { Name: 'Solving Equations - Basics', ShortName: 'solving-equations-basics', Link: 'https://www.youtube.com/embed/fBCtX8GAAPg?rel=0&modestbranding=1' },
              { Name: 'Expressions and Equations from Diagrams', ShortName: 'expressions-and-equations-from-diagrams', Link: 'https://www.youtube.com/embed/yxdKc7pi3Kw?rel=0&modestbranding=1' },
              { Name: 'Inequalities', ShortName: 'inequalities', Link: 'https://www.youtube.com/embed/OeSYrSiIUV8?rel=0&modestbranding=1' },
              { Name: 'Simultaneous Equations', ShortName: 'simultaneous-equations', Link: 'https://www.youtube.com/embed/oMHwdUCQZ28?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Three  -  Graphs',
            Subcategories: [
              { Name: 'Coordinates', ShortName: 'coordinates', Link: 'https://www.youtube.com/embed/LeV681ulA40?rel=0&modestbranding=1' },
              { Name: 'Finding the Equation of a Line', ShortName: 'finding-the-equation-of-a-line', Link: 'https://www.youtube.com/embed/YregLUAUS2k?rel=0&modestbranding=1' },
              { Name: 'Quadratic Graphs', ShortName: 'quadratic-graphs', Link: 'https://www.youtube.com/embed/AVoggiYIoWs?rel=0&modestbranding=1' },
              { Name: 'Conversion Graphs', ShortName: 'conversion-graphs', Link: 'https://www.youtube.com/embed/owcYALk3tso?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Four  -  Ratio, Proportion and Rates of Change',
            Subcategories: [
              { Name: 'Working With Ratios', ShortName: 'working-with-ratios', Link: 'https://www.youtube.com/embed/TC4Nu94xxfw?rel=0&modestbranding=1' },
              { Name: 'Direct Proportion', ShortName: 'direct-proportion', Link: 'https://www.youtube.com/embed/Rzu4BNRss7o?rel=0&modestbranding=1' },
              { Name: 'Inverse Propotion', ShortName: 'inverse-propotion', Link: 'https://www.youtube.com/embed/vHAsRmLGpmI?rel=0&modestbranding=1' },
              { Name: 'Percentage Increase and Decrease', ShortName: 'percentage-increase-and-decrease', Link: 'https://www.youtube.com/embed/-7IX08OJG88?rel=0&modestbranding=1' },
              { Name: 'Compound Interest and Depreciation', ShortName: 'compound-interest-and-depreciation', Link: 'https://www.youtube.com/embed/z-gTLhAhQ5c?rel=0&modestbranding=1' },
              { Name: 'Time Interval Problems', ShortName: 'time-interval-problems', Link: 'https://www.youtube.com/embed/FMl8jqdN2f8?rel=0&modestbranding=1' },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Section Five  -  Shapes and Area',
            Subcategories: [
              { Name: 'Polygons - Names and Properties', ShortName: 'polygons-names-and-properties', Link: 'https://www.youtube.com/embed/PwvsfTvAUac?rel=0&modestbranding=1' },
              { Name: 'Fractional Enlargements', ShortName: 'fractional-enlargements', Link: 'https://www.youtube.com/embed/lNtLlXEmJq8?rel=0&modestbranding=1' },
              { Name: 'Surface Area', ShortName: 'surface-area', Link: 'https://www.youtube.com/embed/2iAvyz9a3H8?rel=0&modestbranding=1' },
              { Name: 'Volume of Spheres, Pyramids and Cones', ShortName: 'volume-of-spheres-pyramids-and-cones', Link: 'https://www.youtube.com/embed/lYEJ5PLBw78?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Six  -  Angles and Geometry',
            Subcategories: [
              { Name: 'Parallel and Intersecting Lines', ShortName: 'parallel-and-intersecting-lines', Link: 'https://www.youtube.com/embed/kQI6ZXXECkk?rel=0&modestbranding=1' },
              { Name: 'Polygons - Interior and Exterior Angles', ShortName: 'polygons-interior-and-exterior-angles', Link: 'https://www.youtube.com/embed/viqrYx-bvKA?rel=0&modestbranding=1' },
              { Name: 'Locus Problems', ShortName: 'locus-problems', Link: 'https://www.youtube.com/embed/MAv7t2_zeNI?rel=0&modestbranding=1' },
              { Name: 'Bearings', ShortName: 'bearings', Link: 'https://www.youtube.com/embed/vG3d1nWyqTA?rel=0&modestbranding=1' },
              { Name: 'Pythagoras\' Theorem', ShortName: 'pythagoras-theorem', Link: 'https://www.youtube.com/embed/LkaASGmbu8E?rel=0&modestbranding=1' },
              { Name: 'Trigonometry', ShortName: 'trigonometry', Link: 'https://www.youtube.com/embed/cFTw04SicwU?rel=0&modestbranding=1' },
              { Name: 'Vectors - Definitions and Stuff', ShortName: 'vectors-definitions-and-stuff', Link: 'https://www.youtube.com/embed/8R4VwNdFCsE?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Seven  -  Probability and Statistics',
            Subcategories: [
              { Name: '\'Balls in a Bag\' Type Problems', ShortName: 'balls-in-a-bag-type-problems', Link: 'https://www.youtube.com/embed/mqqQEKF2hes?rel=0&modestbranding=1' },
              { Name: 'The AND and OR Rules', ShortName: 'the-and-and-or-rules', Link: 'https://www.youtube.com/embed/c8ZGodg2mdI?rel=0&modestbranding=1' },
              { Name: 'Types of Data', ShortName: 'types-of-data', Link: 'https://www.youtube.com/embed/XDe_tqRDSQU?rel=0&modestbranding=1' },
              { Name: 'Drawing Pie Charts', ShortName: 'drawing-pie-charts', Link: 'https://www.youtube.com/embed/0pSAlSZON7c?rel=0&modestbranding=1' },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.HowToRevise,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: 'how-to-revise',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'How to Revise',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>We\'ve spilled all the secrets to help you get the most out of your book and CGP RevisionHub.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Revision tips and tricks',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      // TODO: populate DisplayName, BookType, and AdditionalText for the How to Revise section
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Products',
    ButtonURL: '[[external_domain]]/bookspacedemo',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition  -  yippee!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your e-Book here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    ButtonURL: 'extras',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Printable worked answers, formula sheet and exam tips  -  it\'s all right here.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      // TODO: populate ContentMain with intro text and ContentRight with an image if needed
      HeaderText: 'Extra Useful Bits',
      ContentMain: '<p>Your printable worked answers, formula sheet and exam tips are all below. Take your pick!</p>',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>We can\'t explain the meaning of life, but we can explain how to use your RevisionHub pretty well.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our FAQs',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine: 'We\'ve put together lots of helpful information on how to get the most out of your Revision Guide. And if you\'ve hit any snags, you\'ll find the answers you need here too.',
      Text:
        '<h2>Frequently Asked Questions</h2>\n' +
      '<h5>What is CGP RevisionHub?</h5>\n' +
      '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Maths books. Use the quizzes, videos and more to revise what you\'ve learned from your book and prepare for the exams.</p>\n' +
      '<h5>How do I access CGP RevisionHub?</h5>\n' +
      '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.</p>\n' +
      '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
      '<p>You\'ll notice lots of QR codes scattered throughout your book. Give them a scan and you\'ll automatically be taken to the relevant test, video or other revision thingy-ma-jig so you can go over what you\'ve learned!</p>\n' +
      '<h5>My CGP RevisionHub isn\'t working  —  what do I do?</h5>\n' +
      '<p>If you can\'t find the answer in these FAQs, it\'s time to contact our friendly Customer Services team. You could also ask your friendly neighbourhood psychic, but they will charge...</p>\n' +
      '<h5>Do I need an internet connection to use CGP RevisionHub?</h5>\n' +
      '<p>Yes, you do. But you can also download some handy PDF resources to use offline. Nice.</p>\n' +
      '<h5>If I log in on a different device, will all my progress be saved?</h5>\n' +
      '<p>Yep. Just log in on your computer, tablet or phone, and all your progress will be there waiting for you.</p>\n' +
      '<h5>What\'s the difference between the Quick Quizzes, Your Mistakes Quiz and Revision Summary Tests?</h5>\n' +
      '<p>Quick Quizzes are... well, quick! They\'re a speedy way to test all the maths on the course. Your Mistakes Quiz tests you on all the questions you got wrong in your Quick Quizzes. Revision Summary Tests include more challenging questions  -  mark them yourself using our example answers.</p>\n' +
      '<h5>Can I clear my progress so far in CGP RevisionHub and start again?</h5>\n' +
      '<p>There are no takie-backsies in CGP RevisionHub, so you can\'t clear your results and start again. But, you can have another go at any of the quizzes and they\'ll update to show your latest scores. Keep going, we believe in you!</p>\n' +
      '<h5>Can I share my test results with other people?</h5>\n' +
      '<p>You can\'t share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where\'s the fun in that?</p>\n' +
      '<h5>What happens when I\'ve answered all the questions?</h5>\n' +
      '<p>Ah, one of life\'s greatest questions  —  what next? We\'d recommend that you keep practising right up until your exams.</p>\n' +
      '<h5>Will I always have access to CGP RevisionHub?</h5>\n' +
      '<p>Once you activate the code in the front of your book, you\'ll have access for three years. And they\'ll be three whole years of bliss, we promise.</p>\n',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP Revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>There\'s plenty more revision where this came from! Take a look at some of our other revision books.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },}
];